import React, { createContext, useEffect } from 'react';
import { useHistory } from 'react-router';

export interface Props {
  refId?: string;
}
export interface ReferContextProviderProps {
  children: React.ReactNode;
}

export const ReferContext = createContext<Props>({});

const ReferContextProvider = (props: ReferContextProviderProps) => {
  const { children } = props;
  const history = useHistory();
  let refvar: string | null = new URLSearchParams(history.location.search).get('referral_key');

  useEffect(() => {
    const saveUnLoadTime = () => {
      if (refvar) {
        localStorage.setItem('unload_time', new Date().getTime().toString());
      }
      const currentPath = window.location.href;
      if (
        currentPath.includes('member_sign_in') ||
        currentPath.includes('signup') ||
        currentPath.includes('patient/dashboard/home') ||
        currentPath.includes('account-creation') ||
        process.env.NODE_ENV === 'development'
      )
        return null;
      return '';
    };

    window.onbeforeunload = saveUnLoadTime;
  }, []);

  if (refvar) {
    localStorage.setItem('refKey', refvar);
  } else {
    const unload_time = localStorage.getItem('unload_time');
    if (unload_time && new Date().getTime() - parseInt(unload_time, 10) < 300000) {
      refvar = localStorage.getItem('refKey');
    } else {
      localStorage.removeItem('refKey');
      localStorage.removeItem('unload_time');
    }
  }

  return <ReferContext.Provider value={{ refId: refvar || '' }}>{children}</ReferContext.Provider>;
};

export default ReferContextProvider;
